<template>
    <div class="login-container">
        <div class="login-head">
            <van-nav-bar title="" :border="false" />
        </div>
        <div class="login-logo-area">
            <img class="logo-icon" src="../assets/LOGO.jpg" alt="logo">
            <div class="logo-title">{{ COMPANYNAME }}鹊桥会</div>
            <div class="logo-subtitle">企业内部婚恋交友平台</div>
        </div>
        <div class="login-content">
            <div class="login-title">手机号码</div>
            <van-form @submit="onSubmit">
                <van-field v-model="phoneNumber" name="用户名" maxlength="11" placeholder="请输入手机号码" />
                <!-- :rules="[{ required: true, message: '请输入手机号码' }]" -->
                <div class="login-title login-inputInfo"><span>会员如更换手机号码，请联系管理员更换登录号</span></div>
                <div class="login-title">短信验证码</div>
                <van-field v-model="verificationCode" name="短信验证码" :disabled='disabled' placeholder="请输入短信验证码"
                    maxlength="4" class="login-code">
                    <!-- :rules="[{ required: true, message: '请填写短信验证码' }]" -->
                    <template #button>
                        <span :class="['login-sendCode', { 'login-canSendCode': canSendCode }]"
                            @click="handleSendCode">{{ isSendCode && sendCodeTime > 0 ? `${sendCodeTime}后重新获取` :
                                '发送验证码' }} </span>
                    </template>
                </van-field>
                <div :class="['login-submit', { 'login-submitActive': verificationCode.length > 0 }]">
                    <van-button round block type="info" native-type="submit"
                        :disabled='submitBtnDisabled'>登录</van-button>
                </div>
            </van-form>
            <div class="join-matchmaker-btn">
                <button class="btn btn-secondary" @click="goToMemberRegister">申请成为会员</button>
                <!-- <button class="btn btn-secondary" @click="goToMatchmakerRegister">申请成为红娘</button> -->
            </div>
        </div>
        <div class="login-footer">
            <span>如有任何问题，欢迎联系鹊桥会官方电话：{{ TEL }}</span>
        </div>
        <van-overlay :show="show" class-name='autoLogin'>
            <div class="wrapper" @click.stop>
                <div>
                    <van-loading type="spinner" />
                    <span>{{ loadingInfo }}</span>
                </div>

            </div>
        </van-overlay>
        <!-- 微信登录会员不存在弹窗 -->
        <van-dialog v-model="weChatDialog.show" title="提示" class="login-wechat-dialog" show-cancel-button
            :confirm-button-text="weChatDialog.showBindForm ? '绑定并登录' : '去注册'"
            :cancel-button-text="weChatDialog.showBindForm ? '去注册' : '取消'"
            @confirm="weChatDialog.showBindForm ? bindWeChatAndLogin() : goToRegister()"
            @cancel="weChatDialog.showBindForm ? goToRegister() : null">
            <div class="wechat-dialog-content">
                <p v-if="!weChatDialog.showBindForm">检测到您是首次使用微信登录</p>
                <p v-if="!weChatDialog.showBindForm">如果您已是会员，可以绑定已有账号</p>
                <p v-if="!weChatDialog.showBindForm">或者点击下方按钮注册新账号</p>
                <van-button v-if="!weChatDialog.showBindForm" type="primary" block round style="margin-top: 15px;"
                    @click="showBindForm">
                    绑定已有账号
                </van-button>
                <!-- 绑定账号表单 -->
                <div v-if="weChatDialog.showBindForm" class="bind-form">
                    <p style="margin-bottom: 10px;">请输入您的手机号和验证码绑定账号</p>
                    <van-field v-model="weChatDialog.phoneNumber" placeholder="请输入手机号码" maxlength="11" type="tel" />
                    <van-field v-model="weChatDialog.verificationCode" placeholder="请输入短信验证码" maxlength="4" type="tel">
                        <template #button>
                            <span :class="['login-sendCode', { 'login-canSendCode': weChatDialog.canSendCode }]"
                                @click="handleBindSendCode">{{ weChatDialog.isSendCode && weChatDialog.sendCodeTime > 0
                                    ?
                                    `${weChatDialog.sendCodeTime}后重新获取` : '发送验证码' }}</span>
                        </template>
                    </van-field>
                </div>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import { getToken, setOaInfo } from "@/utils/auth";
import { Toast, Dialog } from "vant";
import {
    autoLogin,
    getInternalRawDataQueryByOaToken,
    getVerificationCode,
    weChatLogin,
    bindWeChatToExistingMember
} from "../api/user";
export default {
    data() {
        return {
            introduction: process.env.INTRODUCTION,
            COMPANYNAME: process.env.COMPANYNAME,
            TEL: process.env.TEL,
            phoneNumber: "",
            verificationCode: "",
            disabled: true, //  验证码输入框
            sendCodeBtn: false, // 发送验证码按钮是否可以点击
            canSendCode: false, // 是否可以发送验证码
            sendCodeTime: 60, //  验证码倒计时
            isSendCode: false, // 是否发送过验证码
            submitBtnDisabled: true, // 登录按钮是否禁止
            show: false,
            loadingInfo: "登录中...",
            weChatDialog: {
                show: false,
                showBindForm: false,
                phoneNumber: "",
                verificationCode: "",
                canSendCode: false,
                isSendCode: false,
                sendCodeTime: 60,
                openid: "" // 微信openid，用于绑定
            }
        };
    },
    methods: {
        redirectAfterLogin() {
            var redirect = this.$route.query.redirect;
            if (!redirect) {
                redirect = "/homePage";
                switch (this.$store.getters.role) {
                    case 'Member':
                        redirect = "/encounter"
                        break;
                    case 'Matchmaker':
                        redirect = "/matchmakerCenter"
                        break;
                }
                // redirect = "/homePage";
            }
            this.$router.replace(redirect);
        },
        clearWeChatAuthParams() {
            // 清除hash中的openid参数
            const hash = window.location.hash;
            if (hash) {
                const newHash = hash.replace(/[?&]openid=[^&]*&?/, "?").replace(/[?&]openid=[^&]*/, "").replace(/\?$/, "").replace(/&$/, "");
                if (newHash !== hash) {
                    const url = window.location.pathname + window.location.search + newHash;
                    window.history.replaceState({}, document.title, url);
                }
            }
        },
        // onClickLeft() {
        //    this.$router.go(-1);
        // },
        // 跳转到申请加入会员页面
        goToMemberRegister() {
            this.$router.push({ path: "/joinMatchmakerTeam" });
        },
        // 跳转到申请加入红娘页面
        goToMatchmakerRegister() {
            this.$router.push({ path: "/joinMatchMaker" });
        },
        // 先验证手机号是否正确，正确则发验证码
        handleSendCode() {
            let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
            if (this.sendCodeBtn && this.sendCodeTime === 60) {
                if (!reg_tel.test(this.phoneNumber)) {
                    Toast.fail({
                        message: "请输入正确的手机号",
                        className: "phoneErrMessage"
                    });
                    return;
                }
                this.disabled = false;
                this.canSendCode = false; //激活过
                const params = {
                    phoneNumber: this.phoneNumber
                };
                getVerificationCode(params).then(res => {
                    // 发送请求
                    if (res.code === 20000) {
                        Toast.success({
                            message: "短信发送成功",
                            className: "phoneErrMessage"
                        });
                        this.isSendCode = true;
                        // 开启倒计时
                        this.countdown();
                        this.sendCodeBtn = false;
                    }
                });
            }
        },
        // 点击登录，发送请求，并打开弹窗
        onSubmit() {
            let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
            if (!reg_tel.test(this.phoneNumber)) {
                Toast.fail({
                    message: "请输入正确的手机号",
                    className: "phoneErrMessage"
                });
                return;
            }
            this.show = true;
            this.loadingInfo = "登录中...";
            const params = {
                phoneNumber: this.phoneNumber,
                verificationCode: this.verificationCode
            };
            // 如果微信免登流程中已获取到openid，SMS登录时一并绑定
            if (this.weChatDialog.openid) {
                params.openId = this.weChatDialog.openid;
            }
            this.$store
                .dispatch("Login", params)
                .then(() => {
                    this.show = false;
                    this.redirectAfterLogin();
                })
                .catch(() => {
                    // 看情况提示
                    this.show = false;
                });
        },
        // 倒计时
        countdown() {
            let auth_timer = setInterval(() => {
                //定时器设置每秒递减
                // this.sendCodeTime = --this.sendCodeTime;        //递减时间
                this.sendCodeTime--;
                if (this.sendCodeTime <= 0) {
                    this.isSendCode = false; //60s时间结束还原v-show状态并清除定时器
                    this.sendCodeTime = 60;
                    this.sendCodeBtn = true;
                    if (this.phoneNumber.length === 11) {
                        this.canSendCode = true;
                    }
                    clearInterval(auth_timer);
                }
            }, 1000);
        },
        // 执行微信登录（openid免登）
        doWeChatLogin(openid) {
            const params = {
                openId: openid
            };
            weChatLogin(params)
                .then(res => {
                    this.show = false;
                    if (res.code === 20000) {
                        const data = res.data;
                        if (data.isMemberExist) {
                            // 会员存在，直接登录
                            this.$store
                                .dispatch("SetToken", data.token)
                                .then(() => {
                                    this.$store
                                        .dispatch("GetInfo")
                                        .then(() => {
                                            this.redirectAfterLogin();
                                        })
                                        .catch(() => {
                                            // 获取信息失败
                                        });
                                });
                        } else {
                            // 会员不存在，保存openid用于后续绑定
                            if (!data.openId) {
                                Toast.fail({
                                    message: "获取微信openid失败，请重试",
                                    className: "phoneErrMessage"
                                });
                                return;
                            }
                            this.weChatDialog.openid = data.openId;
                            this.weChatDialog.show = true;
                        }
                    } else {
                        Toast.fail({
                            message: res.message || "微信登录失败",
                            className: "phoneErrMessage"
                        });
                    }
                })
                .catch(err => {
                    this.show = false;
                    Toast.fail({
                        message: err.message || "微信登录失败",
                        className: "phoneErrMessage"
                    });
                });
        },
        // 判断是否在微信浏览器中
        isWeChatBrowser() {
            const ua = navigator.userAgent.toLowerCase();
            return ua.indexOf("micromessenger") !== -1;
        },
        // 跳转OA服务获取openid（微信环境自动免登）
        redirectToOA() {
            const oaAuthUrl = process.env.VUE_APP_OA_WECHAT_AUTH_URL || "https://oamobile.atlbattery.com/portal/WXOAuth.aspx?reurl=qqhMobile";
            window.location.href = oaAuthUrl;
        },
        // 去注册
        goToRegister() {
            const openid = this.weChatDialog.openid;
            this.weChatDialog.show = false;
            this.resetWeChatDialog();
            this.$router.push({ path: "/joinMatchmakerTeam", query: { openid: openid } });
        },
        // 显示绑定表单
        showBindForm() {
            this.weChatDialog.showBindForm = true;
        },
        // 重置微信弹窗状态
        resetWeChatDialog() {
            this.weChatDialog.showBindForm = false;
            this.weChatDialog.phoneNumber = "";
            this.weChatDialog.verificationCode = "";
            this.weChatDialog.canSendCode = false;
            this.weChatDialog.isSendCode = false;
            this.weChatDialog.sendCodeTime = 60;
            this.weChatDialog.openid = "";
        },
        // 绑定微信并登录
        bindWeChatAndLogin() {
            // 验证手机号和验证码
            let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
            if (!reg_tel.test(this.weChatDialog.phoneNumber)) {
                Toast.fail({
                    message: "请输入正确的手机号",
                    className: "phoneErrMessage"
                });
                return;
            }
            if (this.weChatDialog.verificationCode.length !== 4) {
                Toast.fail({
                    message: "请输入4位验证码",
                    className: "phoneErrMessage"
                });
                return;
            }
            if (!this.weChatDialog.openid) {
                Toast.fail({
                    message: "微信openid缺失，请重新发起微信登录",
                    className: "phoneErrMessage"
                });
                return;
            }

            this.show = true;
            this.loadingInfo = "正在绑定账号...";

            const params = {
                openId: this.weChatDialog.openid,
                phoneNumber: this.weChatDialog.phoneNumber,
                verificationCode: this.weChatDialog.verificationCode
            };

            bindWeChatToExistingMember(params)
                .then(res => {
                    this.show = false;
                    if (res.code === 20000) {
                        Toast.success({
                            message: "绑定成功",
                            className: "phoneErrMessage"
                        });
                        // 绑定成功，直接登录
                        const data = res.data;
                        this.$store
                            .dispatch("SetToken", data.token)
                            .then(() => {
                                this.$store
                                    .dispatch("GetInfo")
                                    .then(() => {
                                        this.weChatDialog.show = false;
                                        this.resetWeChatDialog();
                                        this.redirectAfterLogin();
                                    })
                                    .catch(() => {
                                        // 获取信息失败
                                    });
                            });
                    } else {
                        Toast.fail({
                            message: res.message || "绑定失败",
                            className: "phoneErrMessage"
                        });
                    }
                })
                .catch(err => {
                    this.show = false;
                    Toast.fail({
                        message: err.message || "绑定失败",
                        className: "phoneErrMessage"
                    });
                });
        },
        // 绑定弹窗发送验证码
        handleBindSendCode() {
            if (!this.weChatDialog.isSendCode && this.weChatDialog.sendCodeTime === 60) {
                let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
                if (!reg_tel.test(this.weChatDialog.phoneNumber)) {
                    Toast.fail({
                        message: "请输入正确的手机号",
                        className: "phoneErrMessage"
                    });
                    return;
                }

                this.weChatDialog.canSendCode = false;
                const params = {
                    phoneNumber: this.weChatDialog.phoneNumber
                };
                getVerificationCode(params).then(res => {
                    if (res.code === 20000) {
                        Toast.success({
                            message: "短信发送成功",
                            className: "phoneErrMessage"
                        });
                        this.weChatDialog.isSendCode = true;
                        this.bindCountdown();
                    }
                });
            }
        },
        // 绑定弹窗倒计时
        bindCountdown() {
            let auth_timer = setInterval(() => {
                this.weChatDialog.sendCodeTime--;
                if (this.weChatDialog.sendCodeTime <= 0) {
                    this.weChatDialog.isSendCode = false;
                    this.weChatDialog.sendCodeTime = 60;
                    if (this.weChatDialog.phoneNumber.length === 11) {
                        this.weChatDialog.canSendCode = true;
                    }
                    clearInterval(auth_timer);
                }
            }, 1000);
        }
    },
    created() {
        // 获取到路由的href, 解析出是否有token，如果有则获取用户原始数据，用处申请加入会员或者红娘使用
        const hrefs = location.href;
        if (hrefs.indexOf("?") !== -1) {
            const str = hrefs.substring(hrefs.indexOf("?") + 1, hrefs.length); // 获取URL中?之后的字符（去掉第一位的问号）
            let arr = str.split("&");
            let obj = new Object();
            for (let i = 0; i < arr.length; i++) {
                let tmp_arr = arr[i].split("=");
                obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(
                    tmp_arr[1]
                );
            }
            if (obj.oatoken) {
                let token = obj.oatoken.substring(0, 64);
                const params = {
                    oaToken: token
                };
                getInternalRawDataQueryByOaToken(params)
                    .then(res => {
                        if (res.code === 20000) {
                            if (res.data) {
                                setOaInfo(res.data);
                            } else {
                                setOaInfo("");
                            }
                        } else {
                            setOaInfo("");
                        }
                    })
                    .catch(() => {
                        setOaInfo("");
                    });
            }
        } else {
            setOaInfo("");
        }
        // 如果本地有缓存，且没过期则自动登录（优先级最高）
        if (getToken()) {
            this.show = true;
            this.loadingInfo = "自动登录中...";
            this.$store
                .dispatch("GetInfo")
                .then(res => {
                    this.show = false;
                    this.redirectAfterLogin();
                })
                .catch(() => {
                    this.$store.dispatch("RemoveToken");
                    this.show = false;
                    // token过期，微信环境下走OA免登重试
                    if (this.isWeChatBrowser()) {
                        this.redirectToOA();
                    }
                });
            return;
        }
        // 获取到路由的href, 解析出是否有token，有则自动登录
        if (hrefs.indexOf("?") !== -1) {
            if (!getToken()) {
                const str = hrefs.substring(
                    hrefs.indexOf("?") + 1,
                    hrefs.length
                ); // 获取URL中?之后的字符（去掉第一位的问号）
                let arr = str.split("&");
                let obj = new Object();
                for (let i = 0; i < arr.length; i++) {
                    let tmp_arr = arr[i].split("=");
                    obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(
                        tmp_arr[1]
                    );
                }
                if (obj.oatoken) {
                    let token = obj.oatoken.substring(0, 64);
                    const params = {
                        oaToken: token
                    };
                    this.show = true;
                    this.loadingInfo = "自动登录中...";
                    // 设置token
                    autoLogin(params)
                        .then(res => {
                            // 登录成功，调数据接口
                            if (res.data) {
                                this.$store
                                    .dispatch("SetToken", res.data.token)
                                    .then(() => {
                                        this.$store
                                            .dispatch("GetInfo")
                                            .then(() => {
                                                this.show = false;
                                                this.redirectAfterLogin();
                                            })
                                            .catch(() => {
                                                this.show = false;
                                            });
                                        // this.$router.push({path: '/homePage'});
                                    });
                            } else {
                                this.show = false;
                                this.$store.dispatch("RemoveToken");
                                window.location.replace("/mbc/index.html#/");
                            }
                        })
                        .catch(() => {
                            // location.href = ''
                            this.show = false;
                            this.$store.dispatch("RemoveToken");
                            window.location.replace("/mbc/index.html#/");
                        });
                }
            }
        }

        // 从hash中检测openid（OA服务回调格式: #/?openid=xxx）
        const hash = window.location.hash;
        const openidMatch = hash && hash.match(/[?&]openid=([^&]*)/);
        if (openidMatch && openidMatch[1]) {
            const openid = decodeURIComponent(openidMatch[1]);
            this.clearWeChatAuthParams();
            // 标记已处理过OA回调，避免失败后循环重定向
            sessionStorage.setItem("oa_wechat_processed", "1");
            this.show = true;
            this.loadingInfo = "微信免登中...";
            this.doWeChatLogin(openid);
            return;
        }

        // 微信环境且无token无openid时，自动跳转OA服务获取openid
        // 防止无限重定向：如果已尝试过OA但失败，不再跳转
        if (this.isWeChatBrowser() && !sessionStorage.getItem("oa_wechat_processed")) {
            sessionStorage.setItem("oa_wechat_pending", "1");
            this.redirectToOA();
            return;
        }
    },
    beforeDestroy() {
        this.show = false;
    },
    watch: {
        // 监听手机和验证码输入情况,都满足时,可以登录按钮可以点击
        phoneNumber: function (newData, oldData) {
            if (newData.length === 11) {
                this.sendCodeBtn = true;
                this.canSendCode = true;
                if (
                    this.verificationCode &&
                    this.verificationCode.length === 4
                ) {
                    this.submitBtnDisabled = false;
                }
            } else {
                this.sendCodeBtn = false;
                this.canSendCode = false;
                this.submitBtnDisabled = true;
            }
        },
        verificationCode: function (newData, oldData) {
            if (newData.length === 4) {
                if (this.phoneNumber && this.phoneNumber.length === 11) {
                    this.submitBtnDisabled = false;
                }
            } else {
                this.sendCodeBtn = false;
                this.canSendCode = false;
                this.submitBtnDisabled = true;
            }
        }
    }
};
</script>
<style lang="less" src='../style/login.less' />



// WEBPACK FOOTER //
// src/views/login.vue